"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * A class-interface to define some commons of a service providing access to the data.
 * This is a class-interface (or restricting interface) - a special construct that is an abstract class but serves as an
 * interface to enforce some public members and hide others.
 * @class
 */
var MEDataService = /** @class */ (function () {
    function MEDataService() {
    }
    return MEDataService;
}());
exports.MEDataService = MEDataService;
//# sourceMappingURL=me-data.service.js.map